import Typography from '@mui/material/Typography';
import { Grid5 } from 'iconsax-react';

// ==============================|| LOGO ICON ||============================== //

export default function LogoIcon() {
  return (
    <Typography variant="h5" component="span" sx={{ fontWeight: 700 }}>
      <Grid5 size="25" color="#5B6B79" variant="Bulk" />
    </Typography>
  );
}
